/* Soft readout (DECISIONS 2026-09-23): --panel box, hairline, 4 px radius, --bad label and value */
.readout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s2);
  min-width: 0;
  min-height: 52px;
  padding: 0 var(--s4);
  background: var(--panel);
  border: 1px solid var(--line);
  border-radius: var(--r-readout);
  color: var(--bad);
  text-align: left;
}

button.readout:disabled {
  opacity: 0.45;
  cursor: default;
}

button.readout:active:not(:disabled) {
  background: var(--panel2);
}

.label {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.8125rem;
  line-height: 1.35;
  font-weight: 600;
  font-stretch: 85%;
  overflow-wrap: break-word;
}

.value {
  min-width: 0;
  font-size: 1.75rem;
  line-height: 1;
  overflow-wrap: break-word;
}

.num {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
}

/* Words such as a key ("F minor") stay in Archivo */
.word {
  font-size: 1.5rem;
  font-weight: 650;
  font-stretch: 100%;
}
